@if (Vendor) {
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <h2>Contacts {{ Vendor ? ' - ' + Vendor.legalName : '' }}</h2>
      </div>
    </div>
    <div class="row" style="height: 500px">
      <div class="col">
        @if (suppliedGridQueryData) {
          <app-contacts-grid
            [suppliedQueryData]="suppliedGridQueryData"
            [gridName]="'ClientVendorContacts'"
          >
          </app-contacts-grid>
        }
      </div>
    </div>
  </div>
}
